import { MakeCall } from 'ha/services/apiV2/createMakeCall';

type SitemapResponse = Array<{
  language: string;
  title: string;
  url: string;
}>;

export default (makeCall: MakeCall) => () =>
  makeCall<SitemapResponse>('GET', '/sitemaps/sitemap-c1.json');
